import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import filler from '../../assets/filler.png';
import "react-datepicker/dist/react-datepicker.css";
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const EditUserInfo = ({ address, setAddress, email, setEmail, phoneNumber, setPhoneNumber, birthday, setBirthday }) => {
  const [startDate, setStartDate] = useState(new Date());
  const [imgUrl, setImgUrl] = useState();

  const onChange = (e) => {
    console.log("onchange called");
    const file = e.target.files[0];
    const storage = getStorage();
    const storageRef = ref(storage, 'video/' + file.name);

    try {
      uploadBytes(storageRef, file).then((snapshot) => {
        console.log('Uploaded a data_url string!');
        const starsRef = ref(storage, 'video/' + file.name);
        getDownloadURL(starsRef)
          .then((url) => {
            // Insert url into an <img> tag to "download"
            console.log(url);
            setImgUrl(url);
          })

      });
    } catch (e) {
      console.log("error");
      console.log(e)
    }
  }

  return (
    <div className="flex flex-col justify-center items-center mt-5 lg:h-4/5">
      {/* {fields && (
        <p className="text-red-500 mb-5 text-xl transition-all duration-150 ease-in ">Please add all fields.</p>
      )} */}
      <div className=" flex lg:flex-row flex-col justify-center items-center bg-white lg:p-5 p-3 lg:w-4/5  w-full">
        <div className="flex flex-1 flex-col gap-6 lg:pl-5 mt-5 w-auto">
          {/* <img
            className=" w-full h-100 2xl:h-51 shadow-lg object-cover"
            src={imgUrl ? imgUrl : filler}
            alt="user-pic"
          /> */}

          {/* <video
            src={imgUrl ? imgUrl : filler}
            type="video/mp4"
            loop
            controls={true}
            muted
            autoPlay
            className="w-full h-100 object-cover"
          /> */}

          {/* <div className='flex flex-col'>
            Video: <input
              type="file"
              onChange={onChange}
            // className="border-2 border-gray-200 text-l font-bold p-2 rounded-md bg-white focus:ring-violet-300"
            />
          </div> */}

          <div className='flex flex-col'>
            Email: <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              // placeholder="Add your title"
              className="border-2 border-gray-200 text-l font-bold p-2 rounded-md bg-white focus:ring-violet-300"
            />
          </div>
          <div className='flex flex-col'>
            Phone Number: <input
              type="text"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              className="border-2 border-gray-200 text-l font-bold p-2 rounded-md bg-white focus-within:shadow-sm focus-within:border-red-500"
            />
          </div>
          <div className='flex flex-col'>
            Address
            <input
              type="text"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              className="border-2 border-gray-200 text-l font-bold p-2 rounded-md bg-white focus-within:shadow-sm focus-within:border-red-500"
            />
          </div>
          <div className='flex flex-col'>
            Birthday
            {/* <input
              type="text"
              value={birthday}
              onChange={(e) => setBirthday(e.target.value)}
              className="border-2 border-gray-200 text-l font-bold p-2 rounded-md bg-white focus-within:shadow-sm focus-within:border-red-500"
            /> */}
            <div
              className="border-2 border-gray-200 text-l font-bold p-2 rounded-md bg-white focus-within:shadow-sm focus-within:border-red-500"
            >
              <DatePicker selected={birthday} onChange={(date: Date) => setBirthday(date)} />
            </div>
          </div>
          <div className="flex flex-col">
            <div className="flex justify-end items-end mt-5">

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUserInfo;